export default __webpack_public_path__ + "media/images/svg/pale-in-icon-round-e40fb3e67f5a609815da3b7f067f487e.png";